<template>
  <div class="PortIdentifying">
    <div class="list-area" :class="[disabled ? 'list-disabled-area' : '']">
      <div
        class="li-area"
        :class="[slideIndex == index ? 'li-active-area' : '']"
        v-for="(item, index) in list"
        :key="index"
        @click="liTabClick(item, index)"
      >
        {{ item.name }}
      </div>
      <div class="li-slide" :style="`left:${slideIndex * 46}px`"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: [],
    },
    name: {
      type: String,
      value: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      slideIndex: 0,
    };
  },
  created() {},
  mounted() {},
  methods: {
    liTabClick(item, index) {
      if (this.disabled) return;
      this.slideIndex = index;
      this.$emit("change", item);
    },
  },
};
</script>

<style scoped lang="scss">
.PortIdentifying {
  $slideWidth: 46px;
  $slideHeight: 26px;
  .list-area {
    background: #ecf0f6;
    border: 4px solid #ecf0f6;
    border-radius: 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    position: relative;
    .li-area {
      width: $slideWidth;
      height: $slideHeight;
      font-size: 12px;
      font-weight: bold;
      color: #909399;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      z-index: 2;
      cursor: pointer;
    }
    .li-slide {
      width: $slideWidth;
      height: $slideHeight;
      background: #fff;
      box-shadow: 0px 2px 6px 0px #e2e3e8;
      border-radius: 8px;
      position: absolute;
      z-index: 1;
      left: 0px;
      transition: all 0.35s;
    }
    .li-active-area {
      font-size: 12px;
      font-weight: bold;
      color: var(--theme);
    }
    .li-slide-1 {
      left: 0px;
    }
    .li-slide-2 {
      left: $slideWidth;
    }
  }
  .list-disabled-area {
    cursor: not-allowed;
    .li-area {
      cursor: not-allowed;
    }
    .li-slide {
      cursor: not-allowed;
    }
  }
}
</style>
